import React from "react";
import { Link } from "react-router-dom";
import siteConfig from "../config/siteConfig";
import "../css/privacy.scss";
import "../css/terms.scss";

function Terms() {
  const email = siteConfig.contact?.email;

  return (
    <main className="policy-page terms-page">
      <header className="policy-hero">
        <span className="policy-hero__number">LEGAL / 02</span>
        <p>PLEASE READ BEFORE USING THIS STORE</p>
        <h1>Terms of use.</h1>
        <p className="policy-hero__intro">
          These terms govern your use of the {siteConfig.brandName} website and
          purchases made through it.
        </p>
        <span className="policy-hero__date">Updated September 16, 2026</span>
      </header>

      <div className="policy-layout">
        <aside className="policy-index">
          <p>ON THIS PAGE</p>
          <nav aria-label="Terms of use sections">
            <a href="#terms-store">Using the store</a>
            <a href="#terms-orders">Orders and payment</a>
            <a href="#terms-products">Products and availability</a>
            <a href="#terms-delivery">Delivery and returns</a>
            <a href="#terms-rights">Intellectual property</a>
            <a href="#terms-liability">Liability</a>
            <a href="#terms-contact">Contact</a>
          </nav>
        </aside>

        <article className="policy-content">
          <section id="terms-store">
            <span>01</span>
            <h2>Using the store</h2>
            <p>{siteConfig.brandName} at {siteConfig.website} is operated by {siteConfig.companyName}. Company address: {siteConfig.contact.address}.</p>
            <p>
              By accessing this website, you agree to these terms and all laws
              that apply to you. You must provide accurate information, keep any
              account credentials secure and use the site only for lawful,
              personal shopping purposes.
            </p>
          </section>

          <section id="terms-orders">
            <span>02</span>
            <h2>Orders, pricing and payment</h2>
            <p>The current checkout is a demonstration. It does not collect payment, transmit an order for fulfilment or form a sale. A demo confirmation is not a payment receipt. Contact us to confirm purchasing availability.</p>
            <p>
              An order is an offer to purchase. We may accept or decline it,
              including when an item is unavailable, information is incorrect
              or fraud is suspected. A binding sale is formed when we confirm
              acceptance and dispatch.
            </p>
            <p>
              Prices, taxes and shipping charges are shown before checkout.
              Obvious pricing errors may be corrected and affected orders may
              be cancelled and refunded.
            </p>
          </section>

          <section id="terms-products">
            <span>03</span>
            <h2>Products and availability</h2>
            <p>Product and editorial images are digitally generated illustrations based on the listed styles. They are not photographs of stock or evidence of an owned factory. Confirm material details with us before purchasing.</p>
            <p>
              We work to present colours, textures, measurements and stock
              accurately. Screens and natural materials can vary, and small
              differences are not defects. Product availability can change
              until an order is accepted.
            </p>
          </section>

          <section id="terms-delivery">
            <span>04</span>
            <h2>Delivery, returns and risk</h2>
            <p>
              Delivery estimates are not guarantees. Risk passes to you when
              the order is delivered to the address supplied. Shipping and
              return eligibility are described in the policies available below.
            </p>
            <div className="policy-contact-links">
              <Link to="/shipping">Shipping policy</Link>
              <Link to="/returns">Return policy</Link>
            </div>
          </section>

          <section id="terms-rights">
            <span>05</span>
            <h2>Intellectual property</h2>
            <p>
              The suddlecorner identity and original site materials are used
              by {siteConfig.companyName}. Rights in third-party software and
              fonts remain with their respective owners. No affiliation with
              another clothing brand is implied. Reuse is subject to any
              applicable rights and licences.
            </p>
          </section>

          <section id="terms-liability">
            <span>06</span>
            <h2>Liability</h2>
            <p>
              To the fullest extent allowed by law, the site is provided as
              available and we are not liable for indirect or consequential
              loss. Nothing in these terms excludes rights or remedies that
              cannot legally be excluded.
            </p>
          </section>

          <section id="terms-contact">
            <span>07</span>
            <h2>Changes and contact</h2>
            <p>{siteConfig.companyName}<br />{siteConfig.contact.address}</p>
            <p>
              We may revise these terms when the store, our practices or the law
              changes. The effective date above shows the latest revision.
            </p>
            <div className="policy-contact-links">
              <Link to="/contact">Contact form</Link>
              {email && <a href={`mailto:${email}`}>{email}</a>}
            </div>
          </section>
        </article>
      </div>
    </main>
  );
}

export default Terms;
